import { render, staticRenderFns } from "./SlidingTabMenu.vue?vue&type=template&id=0cef9e38"
import script from "./SlidingTabMenu.vue?vue&type=script&lang=ts"
export * from "./SlidingTabMenu.vue?vue&type=script&lang=ts"
import style0 from "./SlidingTabMenu.vue?vue&type=style&index=0&id=0cef9e38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports